import React, { useEffect, useRef, useState } from 'react';
import { Copy, Edit, MoreVertical, Trash2 } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import './EntityRow.css';

const EntityRow = ({ item, onToggle, onEdit, onClone, onDelete }) => {

    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setMenuOpen(false);
            }
        };
        if (menuOpen) document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [menuOpen]);

    const handleMenuAction = (action) => {
        setMenuOpen(false);
        if (action === 'edit' && onEdit) onEdit(item);
        if (action === 'clone' && onClone) onClone(item);
        if (action === 'delete' && onDelete) onDelete(item.id);
    };

    const getAvatarGradient = (name) => {
        return 'linear-gradient(to bottom right, #3b82f6, #a855f7)';
    };

    // Generate initials from name
    const getInitials = (name) => {
        const words = name.split(' ').filter(word => word.length > 0);
        if (words.length >= 2) {
            return (words[0][0] + words[1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    };

    // Format relative time from ISO timestamp
    const getRelativeTime = (isoTimestamp) => {
        if (!isoTimestamp) return 'Never';
        try {
            return formatDistanceToNow(new Date(isoTimestamp + 'Z'), { addSuffix: true });
        } catch (error) {
            console.error('Error formatting date:', error);
            return 'Unknown';
        }
    };

    // Get database type display name
    const getDatabaseTypeDisplay = (dbType) => {
        if (!dbType) return 'Unknown';
        return dbType.charAt(0).toUpperCase() + dbType.slice(1);
    };

    const initials = getInitials(item.name);
    const relativeTime = getRelativeTime(item.last_connected_at);
    const databaseType = getDatabaseTypeDisplay(item.database_type);
    const statusText = !item.is_tested ? 'Not Tested' : item.is_connected_successfully ? 'OK' : 'Failed';
    const statusClass = !item.is_tested ? 'nottested' : item.is_connected_successfully ? 'tested' : 'failed';

    return (
        <div className="connection-row">
            <div className="connection-main">
                <div
                    className="connection-avatar"
                    style={{ background: getAvatarGradient(item.name) }}
                >
                    {initials}
                </div>
                <div className="connection-details">
                    <h4 className="connection-name">{item.name}</h4>
                    <p className="connection-provider">{databaseType}</p>
                    <div className="connection-meta">
                        <span className="connected-time">
                            Last Connected: {relativeTime}
                        </span>
                        <span className={`connection-status-pill ${statusClass}`}>
                            {statusText}
                        </span>
                    </div>
                </div>
            </div>

            <div className="connection-actions">
                <label className="toggle-switch">
                    <input
                        type="checkbox"
                        checked={item.is_active || false}
                        onChange={() => onToggle(item.id)}
                    />
                    <span className="toggle-slider"></span>
                </label>
                {/* <button className="connection-edit-btn" onClick={handleEdit}>
                    <Edit style={{ width: '1.25vw', height: '1.25vw' }} />
                </button> */}

                <div className="more-menu-wrapper" ref={menuRef}>
                    <button
                        className="more-menu-btn"
                        onClick={() => setMenuOpen((prev) => !prev)}
                        aria-label="More options"
                    >
                        <MoreVertical style={{ width: "1.25vw", height: "1.25vw" }} />
                    </button>

                    {menuOpen && (
                        <div className="more-menu-dropdown">
                            <button
                                className="more-menu-item"
                                onClick={() => handleMenuAction("edit")}
                            >
                                <Edit style={{ width: "0.833vw", height: "0.833vw" }} />
                                <span>Edit</span>
                            </button>
                            <button
                                className="more-menu-item"
                                onClick={() => handleMenuAction("clone")}
                            >
                                <Copy style={{ width: "0.833vw", height: "0.833vw" }} />
                                <span>Clone</span>
                            </button>
                            {!item.is_active && (
                                <button
                                    className="more-menu-item more-menu-item--delete"
                                    onClick={() => handleMenuAction("delete")}
                                >
                                    <Trash2 style={{ width: "0.833vw", height: "0.833vw" }} />
                                    <span>Delete</span>
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EntityRow;
